import React, { useEffect, useRef } from 'react';
import { chunk } from 'lodash';
import styled from 'styled-components';
import mobilePage01 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-01.png';
import mobilePage02 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-02.png';
import mobilePage03 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-03.png';
import mobilePage04 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-04.png';
import mobilePage05 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-05.png';
import mobilePage06Bg from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-06-bg.png';
import mobilePage06Content from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-06-content.png';
import mobilePage07 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-07.png';
import mobilePage08Bg from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-08-bg.png';
import mobilePage08Content from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-08-content.png';
import mobilePage09 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-09.png';
import mobilePage11 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-11.png';
import mobilePage12 from '../../assets/images/pages/lectures/interview-master-class-basic/mobile/page-12.png';
import chevronRightIcon from './chevron-right.svg';
import LectureReviewCard, { LectureReview } from './LectureReviewCard';

interface InterviewMasterClassBasicPageMobileUIProps {
  purchaseInfo: {
    isPurchased: boolean;
    endDatetime: string;
  };
  onClickCTA: () => void;
  reviews: LectureReview[];
}

function InterviewMasterClassBasicPageMobileUI({
  purchaseInfo,
  onClickCTA: handleClickCTA,
  reviews,
}: InterviewMasterClassBasicPageMobileUIProps) {
  const swiperRef = useRef<any>();
  const chunkedReviews = chunk(reviews, 2);

  useEffect(() => {
    swiperRef.current = new window.Swiper('.swiper', {
      spaceBetween: 12,
      slidesPerView: 1.2,
      loop: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
    });
  }, []);

  const handleClickNextReviewsButton = () => swiperRef.current.slideNext();

  return (
    <StyledContainer>
      <img src={mobilePage01} className='section' alt='page-01' />
      <div className='page-02-wrapper'>
        <img src={mobilePage02} className='section' alt='page-02' />
        <button onClick={handleClickCTA}>
          {purchaseInfo.isPurchased && <span>만료일 : {purchaseInfo.endDatetime}</span>}
          {purchaseInfo.isPurchased ? '시청하기' : '결제하기'}
        </button>
      </div>
      <img src={mobilePage03} className='section' alt='page-03' />
      <img src={mobilePage04} className='section' alt='page-04' />
      <img src={mobilePage05} className='section' alt='page-05' />
      <div className='page-06-wrapper'>
        <img src={mobilePage06Bg} className='section' alt='page-06-bg' />

        <div className='slides-container'>
          <img src={mobilePage06Content} alt='page-06-content' />
        </div>
      </div>
      <img src={mobilePage07} className='section' alt='page-07' />

      <div className='page-08-wrapper'>
        <img src={mobilePage08Bg} className='section' alt='page-08-bg' />

        <div className='slides-container'>
          <img src={mobilePage08Content} alt='page-08-content' />
        </div>
      </div>

      <div className='page-09-wrapper'>
        <img src={mobilePage09} className='section' alt='page-09' />
        <div className='sample-video-1'>
          <iframe
            src='https://player.vimeo.com/video/1027569531?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
            frameBorder='0'
            allow='autoplay; fullscreen; picture-in-picture; clipboard-write'
            title='JK_04_Fit 인터뷰 준비하기 - Fit 인터뷰 접근법'
          ></iframe>
          <script src='https://player.vimeo.com/api/player.js'></script>
        </div>
        <div className='sample-video-2'>
          <iframe
            src='https://player.vimeo.com/video/1027563906?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
            frameBorder='0'
            allow='autoplay; fullscreen; picture-in-picture; clipboard-write'
            title='Han_02_Case 인터뷰 준비하기 - Case 유형 1_Turnaround'
          ></iframe>
          <script src='https://player.vimeo.com/api/player.js'></script>
        </div>
      </div>

      <div className='page-10-wrapper'>
        <h5>수강 후기</h5>

        <div className='lecture-reviews'>
          <div className='swiper'>
            <div className='swiper-wrapper'>
              {chunkedReviews.map((reviews) => (
                <div className='lecture-reviews-chunk swiper-slide'>
                  {reviews.map((review) => (
                    <LectureReviewCard review={review} key={review.id} />
                  ))}
                </div>
              ))}
            </div>
          </div>
          <button className='next-reviews-button' onClick={handleClickNextReviewsButton}>
            <img src={chevronRightIcon} alt='chevron-right' />
          </button>
        </div>
      </div>

      <div className='page-11-wrapper'>
        <img src={mobilePage11} className='section' alt='page-11' />
        <button onClick={handleClickCTA}>
          {purchaseInfo.isPurchased && <span>만료일 : {purchaseInfo.endDatetime}</span>}
          {purchaseInfo.isPurchased ? '시청하기' : '결제하기'}
        </button>
      </div>
      <img src={mobilePage12} className='section' alt='page-12' />
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css');
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');

  font-family: 'Pretendard' !important;

  .section {
    width: 100%;
  }

  .page-02-wrapper {
    position: relative;

    > button {
      all: unset;
      box-sizing: border-box;
      background-color: transparent;
      position: absolute;
      left: 10.666667%;
      top: 70.331588%;
      width: 78.666667%;
      height: 10.471204%;
      cursor: pointer;
      background-color: #3cac40;
      color: white;
      font-size: 4.5vw;
      font-weight: 700;
      text-align: center;
      border-radius: 10px;

      > span {
        position: absolute;
        top: -7.1vw;
        right: 0;
        font-size: 2.8vw;
        color: #555555;
        font-weight: 400;
      }
    }
  }

  .page-06-wrapper {
    position: relative;

    > .slides-container {
      position: absolute;
      top: 29.778672%;
      bottom: 6.036217%;
      left: 0;
      right: 0;
      overflow-x: scroll;
      padding: 0 5.333333%;

      > img {
        height: 100%;
      }

      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .page-08-wrapper {
    position: relative;

    > .slides-container {
      position: absolute;
      top: 41.059603%;
      bottom: 4.966887%;
      left: 0;
      right: 0;
      overflow-x: scroll;
      padding: 0 5.333333%;

      > img {
        height: 100%;
      }

      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .page-09-wrapper {
    position: relative;

    > .sample-video-1 {
      position: absolute;
      top: 21.151439%;
      left: 5.333333%;
      width: 89.333333%;
      height: 23.779725%;
      > iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    > .sample-video-2 {
      position: absolute;
      top: 59.324155%;
      left: 5.333333%;
      width: 89.333333%;
      height: 23.779725%;
      > iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }

  .page-10-wrapper {
    position: relative;
    padding: 60px 0px;

    > h5 {
      font-weight: 700;
      font-size: 28px;
      color: black;
      margin: 0;
      margin-bottom: 42px;
      text-align: center;
    }

    .lecture-reviews {
      /* overflow-x: hidden; */
      position: relative;

      > .next-reviews-button {
        all: unset;
        cursor: pointer;
        background-color: white;
        width: 52px;
        height: 52px;
        border-radius: 100%;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
        position: absolute;
        bottom: 50%;
        transform: translateY(50%);
        right: 20px;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      /* overflow-x: scroll;
        display: flex; */

      .lecture-reviews-chunk {
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-auto-flow: column;
        gap: 18px;
      }
    }
  }

  .page-11-wrapper {
    position: relative;

    > button {
      all: unset;
      box-sizing: border-box;
      background-color: transparent;
      position: absolute;
      left: 10.666667%;
      top: 70.331588%;
      width: 78.666667%;
      height: 10.471204%;
      cursor: pointer;
      background-color: #3cac40;
      color: white;
      font-size: 4.5vw;
      font-weight: 700;
      text-align: center;
      border-radius: 10px;

      > span {
        position: absolute;
        top: -7.1vw;
        right: 0;
        font-size: 2.8vw;
        color: #555555;
        font-weight: 400;
      }
    }
  }
`;

export default InterviewMasterClassBasicPageMobileUI;
